import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FormlyTranslateAdapter } from '@intalio/formly-builder';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AvsecTranslateAdapter extends FormlyTranslateAdapter {
  private ts = inject(TranslateService);

  get currentLang(): string {
    return this.ts.currentLang;
  }

  get onLangChange(): Observable<{ lang: string }> {
    return this.ts.onLangChange as unknown as Observable<{ lang: string }>;
  }

  get(key: string): Observable<string> {
    return this.ts.get(key) as unknown as Observable<string>;
  }

  instant(key: string): string {
    return this.ts.instant(key) as string;
  }
}
